import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { MODAL_TYPES } from '../constants';

type ModalType = (typeof MODAL_TYPES)[keyof typeof MODAL_TYPES];

type CreditsShortageModalStore = {
  isOpen: boolean;
  modalType: ModalType;
  necessaryCredits?: number;
  purchasedCredits?: number;
  balanceBeforePurchase?: number;

  // Actions
  closeModal: () => void;
  openTrialLimitationModal: () => void;
  openPurchaseSuccessModal: (purchasedCredits: number, balanceBeforePurchase: number) => void;
  openCreditsShortageModal: (necessaryCredits?: number) => void;
  openEnterpriseCreditsModal: (necessaryCredits?: number) => void;
};

const store = (set) => ({
  isOpen: false,
  modalType: null,
  necessaryCredits: undefined,
  purchasedCredits: undefined,
  balanceBeforePurchase: undefined,

  openEnterpriseCreditsModal: (necessaryCredits?: number) =>
    set(
      {
        isOpen: true,
        modalType: MODAL_TYPES.ENTERPRISE_CREDITS_EXHAUSTED,
        necessaryCredits,
      },
      false,
      'openEnterpriseCreditsModal'
    ),

  openCreditsShortageModal: (necessaryCredits?: number) =>
    set(
      {
        isOpen: true,
        modalType: MODAL_TYPES.CREDIT_TOPUP,
        necessaryCredits,
      },
      false,
      'openCreditsShortageModal'
    ),

  openTrialLimitationModal: () =>
    set(
      {
        isOpen: true,
        modalType: MODAL_TYPES.TRIAL_LIMITATION,
      },
      false,
      'openTrialLimitationModal'
    ),

  openPurchaseSuccessModal: (purchasedCredits: number, balanceBeforePurchase: number) =>
    set(
      {
        isOpen: true,
        modalType: MODAL_TYPES.PURCHASE_SUCCESS,
        purchasedCredits,
        balanceBeforePurchase,
      },
      false,
      'openPurchaseSuccessModal'
    ),

  closeModal: () =>
    set(
      {
        isOpen: false,
        modalType: null,
        necessaryCredits: undefined,
        purchasedCredits: undefined,
        balanceBeforePurchase: undefined,
      },
      false,
      'closeModal'
    ),
});

export const useCreditsShortageModalStore = create<CreditsShortageModalStore>()(
  process.env.NODE_ENV === 'development' ? devtools(store, { name: 'credits-shortage-modal-store' }) : store
);
